/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check

import { Box, Button, Flex, Text } from '@bottlebooks/gatsby-theme-base';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import React from 'react';
import { jsx } from 'theme-ui';
import { gql } from 'urql';
import { TicketButtonFragment } from '../../../@bottlebooks/gatsby-theme-event/components/Layout/TicketButton';
import { useEventThemeFragment } from '../../../@bottlebooks/gatsby-theme-event/components/Layout/useEventTheme';
import { useFooterQueryFragment } from '../../../@bottlebooks/gatsby-theme-event/components/Layout/useFooterQuery';
import useMenuQuery from '../../../@bottlebooks/gatsby-theme-event/components/Layout/useMenuQuery';
import { ErrorSection, SanityPage } from '../../../components';
import usePreviewData, { PreviewDataProvider } from '../../../usePreviewData';

export default function NoPreviewPage(props) {
  const {
    pathContext: { collectionId },
  } = props;
  return (
    <PreviewDataProvider query={clientQuery} variables={{ collectionId }}>
      <PreviewSanityPage {...props} />
    </PreviewDataProvider>
  );
}

function PreviewSanityPage(props) {
  const [result, reexecuteQuery] = usePreviewData();
  // We have to use a manual polling strategy here because Urql doesn't have native support
  const [counter, setCounter] = React.useState(0);
  React.useEffect(() => {
    setTimeout(() => {
      reexecuteQuery();
      setCounter(counter + 1);
    }, 2000);
  }, [counter, reexecuteQuery]);

  const { data, fetching, error } = result;
  const site = data?.allSite?.[0];

  if (!data)
    return (
      <Flex align="center" justify="center" sx={{ height: '100vh' }}>
        <Text>Loading Preview</Text>
      </Flex>
    );

  if (error) {
    return (
      <ErrorSection error={error}>
        <Text>
          Potential solution: Check that CORS is active for this site. Ensure
          that 'Allow Credentials' is checked.
        </Text>
        <Box sx={{ marginTop: 2 }}>
          <Button
            variant="primary"
            href={`https://www.sanity.io/manage/project/${process.env.GATSBY_SANITY_PROJECT_ID}/api`}
            target="_blank"
          >
            <Text>Go to Sanity project</Text>
          </Button>
        </Box>
      </ErrorSection>
    );
  }

  // const { slug } = afterQuery(data);
  return (
    <Box>
      <Flex
        align="center"
        justify="center"
        sx={{ paddingY: 3, backgroundColor: '#f3f3f3' }}
      >
        <Text>
          This is a preview.{'  '}
          <a href="/">View live version.</a>
        </Text>
      </Flex>
      <Layout page={{ title: 'No preview for this page' }} locale="en">
        <ErrorSection error={{ message: 'No live preview' }}>
          <Text>
            There is no live preview available for this page. Pages generated by
            Bottlebooks do not have a live preview.
          </Text>
        </ErrorSection>
      </Layout>
    </Box>
  );
}

function afterQuery({ Page, draft }) {
  return draft || Page;
}

const clientQuery = gql`
  query ($collectionId: String!) {
    allSite(where: { collectionId: { eq: $collectionId } }) {
      frontpage {
        ...SanityPage
        __typename
        id: _id
        title
        slug {
          current
        }
      }
      ...useEventThemeFragment
      ...useFooterQueryFragment
      ...useMenuQueryFragment
      ...TicketButtonFragment
    }
  }
  ${SanityPage.fragment}
  ${useMenuQuery.fragment}
  ${useFooterQueryFragment}
  ${TicketButtonFragment}
  ${useEventThemeFragment}
`;
